import React, { useEffect, useRef, useState } from 'react';
import {ContractExceptionFields} from '../../Crewing/components/ContractExceptionFields';
import { getVesselList } from '../../Management/core/_requests';
import { getCrewList, getRanks, signOnCrew } from '../core/_requests';
import { toast } from 'react-toastify';
import { Vessel } from '../../operations/core/_models';
import { Crew, Rank } from '../core/_models';

import { useAuth } from '../../auth';
import { KTSVG } from '../../../../_metronic/helpers';
import SearchableSelect from '../../../shared/components/SearchableSelect'

interface Props {
  isOpen: boolean;
  onClose: () => void;
  /** Called with the API response after a successful sign-on. */
  onSignedOn: (data: {
    id: number;
    vesselId: number;
    crewId: number;
    signOnDate: string;
    signOnTime?: string | null;
    portSignOn: string;
    status: string;
    loginLink: string;
  }) => void;
}

const SignOnModal: React.FC<Props> = ({ onClose, isOpen, onSignedOn  }) => {
    const { currentUser } = useAuth();
    const roleId       = currentUser?.role?.id;
    const roleEntityId = currentUser?.roleEntityId;

    const [vessels, setVessels] = useState<Vessel[]>([]);
    const [crews,   setCrews]   = useState<Crew[]>([]);
    const [ranks,   setRanks]   = useState<Rank[]>([]);
    const [rankMap, setRankMap] = useState<Record<number,string>>({});

    const [selectedVesselId, setSelectedVesselId] = useState<number | ''>('');
    const [selectedCrewId,   setSelectedCrewId]   = useState<number | ''>('');
  const [contractStartDate, setContractStartDate] = useState('');
  const [contractEndDate,   setContractEndDate]   = useState('');
  const [contractBufferException, setContractBufferException] = useState(false);
  const [contractBufferExceptionReason, setContractBufferExceptionReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitLock = useRef(false);
  useEffect(() => {
    setContractBufferException(false);
    setContractBufferExceptionReason('');
  }, [selectedCrewId, selectedVesselId, contractEndDate, contractStartDate, isOpen]);
  const [signOnTime,         setSignOnTime]       = useState(() =>
    new Date().toISOString().slice(11, 16)
  );
  const [selectedReliever,  setSelectedReliever]  = useState('');
    const [error,            setError]            = useState('');
    

    // Only show approved crews in the dropdown
const onlyApproved = (list: Crew[]) => list.filter(c => c.approvalStatus === 'APPROVED');


    useEffect(() => {
        // 1️⃣ vessels
        fetchVessels();
        // 2️⃣ crews
    getCrewList()
      .then(list => setCrews(onlyApproved(list))) 
      .catch(console.error);

      console.log("crews aye: ", crews)

      console.log("currentUser: ", currentUser)

// 3️⃣ ranks → build map
    getRanks()
      .then(rs => {
        setRanks(rs);
        const m: Record<number,string> = {};
        rs.forEach(r => (m[r.id] = r.rank));
        setRankMap(m);
      }).catch(console.error);

      if (roleId === 4) {
    const vesselFromAuth = currentUser?.vessel;
    if (vesselFromAuth) {
      setSelectedVesselId(vesselFromAuth.id);
      handleVesselChange(vesselFromAuth.id); // Directly filter crew for role 4
    }
  }

    }, [roleId, roleEntityId]);



    const fetchVessels = async () => {
        try {
            const vesselList = await getVesselList();

            const vesselsForCompany = vesselList.filter(vessel => {
                const isActive = vessel.active;

                if (roleId === 1) {
                    // Super Admin: return all active vessels
                    return isActive;
                } else if (roleId === 5) {
                    // Group Admin: return active vessels assigned to their group
                    return isActive && vessel.companyGroupAdmin?.id === roleEntityId;
                } else if (roleId === 2) {
                    // Company Admin: return active vessels assigned to their company
                    return isActive && vessel.companyAdmin?.id === roleEntityId;
                }

                return false; // default: no access
            });

            setVessels(vesselsForCompany);

    //         // For roleId 4, preselect vessel and filter crews directly
    //   if (roleId === 4) {
    //     const vesselFromAuth = currentUser?.vessel;
    //     if (vesselFromAuth) {
    //       setSelectedVesselId(vesselFromAuth.id);
    //       filterCrewsByVessel(vesselFromAuth.id);
    //     }
    //   }
        } catch (error) {
            console.error('Failed to fetch vessel list:', error);
        }
    };

    // For role 4, directly filter the crews based on vessel
  const filterCrewsByVessel = async (vesselId: number) => {
    const selectedVessel = vessels.find(v => v.id === vesselId);
    if (selectedVessel) {
      const companyAdminId = selectedVessel.companyAdmin?.id;
      const companyGroupAdminId = selectedVessel.companyGroupAdmin?.id;

      try {
        const crewList = await getCrewList(); // Await the crew list here
        const filteredCrews = onlyApproved(crewList).filter(crew => {
          if (companyGroupAdminId && crew.companyGroupAdminId === companyGroupAdminId) {
            return true;
          }
          if (companyAdminId && crew.companyAdminId === companyAdminId) {
            return true;
          }
          return false;
        });
        setCrews(filteredCrews);

        // Safety: clear selection if it’s not in the approved list
if (!filteredCrews.some(c => c.id === Number(selectedCrewId))) {
  setSelectedCrewId('');
}
      } catch (error) {
        console.error('Failed to fetch crew list:', error);
      }
    }
  };


if (!isOpen) return null;

// When a vessel is selected, filter the crew based on the vessel's associated company or sub-company
  const handleVesselChange = async (vesselId: number) => {
    setSelectedVesselId(vesselId);

    if (!vesselId) {
      setCrews([]); // Reset crews if no vessel is selected
      return;
    }

    const selectedVessel = vessels.find(v => v.id === vesselId);
    if (selectedVessel) {
      const companyAdminId = selectedVessel.companyAdmin?.id;
      const companyGroupAdminId = selectedVessel.companyGroupAdmin?.id;

      try {
        const crewList = await getCrewList(); // Fetch the crew list
        const filteredCrews = onlyApproved(crewList).filter(crew => {
          // Filter crew based on the selected vessel's company or sub-company
          if (companyGroupAdminId && crew.companyGroupAdminId === companyGroupAdminId) {
            return true;
          }
          if (companyAdminId && crew.companyAdminId === companyAdminId) {
            return true;
          }
          return false;
        });
        setCrews(filteredCrews);

        // Safety: clear selection if it’s not in the approved list
if (!filteredCrews.some(c => c.id === Number(selectedCrewId))) {
  setSelectedCrewId('');
}
      } catch (error) {
        console.error('Failed to fetch crew list:', error);
      }
    }
  };

    const handleSubmit = async () => {
    if (submitLock.current) return;
    if (contractBufferException && (!contractBufferExceptionReason.trim() || contractBufferExceptionReason.trim().length > 1000)) {
      setError('Enter document exception remarks of 1 to 1000 characters.');
      return;
    }
    if (
    //   !selectedVesselId ||
      !selectedCrewId   ||
      !contractStartDate ||
      !contractEndDate ||
      !signOnTime
    ) {
      setError('Please fill in all fields.');
      return;
    }

    setError('');

    // For roleId 4, use the vessel from currentUser, else use selectedVesselId
  const vesselIdToSend = roleId === 4 ? currentUser?.vessel?.id : selectedVesselId;

  if (!vesselIdToSend) {
    setError('Vessel is required.');
    return;
  }

    try {
      submitLock.current = true;
      setIsSubmitting(true);
      const payload = {
        vesselId:   Number(vesselIdToSend),
        crewId:     Number(selectedCrewId),
        contractStartDate,
        contractEndDate,
        signOnDate: contractStartDate,
        signOnTime,
        relieverId: selectedReliever,
        contractBufferException,
        contractBufferExceptionReason: contractBufferException ? contractBufferExceptionReason.trim() : undefined
      };

      const resp = await signOnCrew(payload);
      const vessel = vessels.find(v => v.id === selectedVesselId)!;
      const loginLink = `https://fleetdoctor.dexpertsystems.in/auth/${vessel.vesselType}/${vessel.imoNumber}/ship-login`;

      // build the exact same URL you used in AddCrewModal

      toast.success('Crew signed on successfully');
      onSignedOn({
        id:         resp.id,
        vesselId:   resp.vesselId,
        crewId:     resp.crewId,
        signOnDate: resp.signOnDate,
        signOnTime: resp.signOnTime ?? signOnTime,
        portSignOn: resp.portSignOn,
        status:     resp.status,
        loginLink,
      });
      onClose();
    } catch (err: any) {
    console.error(err);

    if (err?.response?.data?.message?.includes("is already signed on that vessel")) {
      toast.error(`The selected rank is already assigned to this vessel.`);
    } else {
      toast.error(err?.response?.data?.message || 'Failed to sign on crew');
    }

    } finally {
      submitLock.current = false;
      setIsSubmitting(false);
    }
  };

  // Lookup selected crew to show its rank
  const selectedCrew = crews.find(c => c.id === selectedCrewId);


    return (
        <div className="modal-overlay">
            <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: '70rem' }}
            >
                <div className="custom-modal-header d-flex justify-content-between align-items-center">
                    <h5 className="m-0">Sign On Crew</h5>
                    <button className="close-btn" onClick={onClose}>
                        <KTSVG path='/media/map/x.svg' className='svg-icon-2x' />
                    </button>
                </div>

                <div className="custom-modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}

                    <div className="row gy-4">
                       {/* For roleId 4, hide Vessel selection */}
            {roleId !== 4 && (
              <div className="col-md-6">
                <label className="modal_label">Select Vessel <span className="text-danger">*</span></label>
                <SearchableSelect
                  className="form-select"
                  value={selectedVesselId}
                  onChange={e => handleVesselChange(Number(e.target.value))}
                >
                  <option value="">-- Select Vessel --</option>
                  {vessels.map(v => (
                    <option key={v.id} value={v.id}>{v.fleet_name}</option>
                  ))}
                </SearchableSelect>
              </div>
            )}

                        {/* 2) Crew */}
                            <div className="col-md-6">
                            <label className="modal_label" >Select Crew <span className="text-danger">*</span></label>
                            <SearchableSelect
                                className="form-select"
                                value={selectedCrewId}
                                onChange={e => setSelectedCrewId(Number(e.target.value))}
                                    disabled={!selectedVesselId && roleId !== 4}// Disable crew selection until a vessel is selected, except for role 4
                                >
                                <option value="">-- Select Crew --</option>
                                {crews.map(c => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                                ))}
                            </SearchableSelect>
                            </div>

                        {/* 3) Rank (read-only) */}
                        <div className="col-md-6">
                            <label className='modal_label' htmlFor="rank">Crew Rank <span className="text-danger">*</span></label>
                           
                                <input
                                type="text"
                                className="form-control"
                                readOnly
                                value={selectedCrew ? rankMap[selectedCrew.rankId] || '' : ''}
                                placeholder="—"
                            />
                        </div>

            {/* 4) Contract Start Date */}
            <div className="col-md-6">
              <label className="modal_label">Contract Start Date <span className="text-danger">*</span></label>
              <input
                type="date"
                className="form-control"
                value={contractStartDate}
                onChange={e => setContractStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label className="modal_label">Sign On Time <span className="text-danger">*</span></label>
              <input
                type="time"
                className="form-control"
                value={signOnTime}
                onChange={e => setSignOnTime(e.target.value)}
              />
            </div>

            {/* 5) Contract End Date */}
            <div className="col-md-6">
              <label className="modal_label">Contract End Date <span className="text-danger">*</span></label>
              <input
                type="date"
                className="form-control"
                value={contractEndDate}
                onChange={e => setContractEndDate(e.target.value)}
              />
            </div>

            {/* Select Reliever */}
            <div className="col-md-6">
              <label className="modal_label">Select Reliever</label>
              <SearchableSelect
                className="form-select"
                value={selectedReliever}
                onChange={e => setSelectedReliever(e.target.value)}
              >
                <option value="">-- Select Reliever --</option>
                {crews
                  .filter(c => c.id !== selectedCrewId) // Exclude the current crew member
                  .map(c => (
                    <option key={c.id} value={c.id}>
                      {c.name} - {rankMap[c.rankId] ?? 'Unknown Rank'}
                    </option>
                  ))
                }
              </SearchableSelect>
            </div>
                    </div>
                </div>

                <ContractExceptionFields checked={contractBufferException} reason={contractBufferExceptionReason}
                  onChecked={setContractBufferException} onReason={setContractBufferExceptionReason} disabled={isSubmitting} />
                <div className="d-flex justify-content-end gap-2">
                    <button className="btn btn_secondary" onClick={onClose} disabled={isSubmitting}>Cancel</button>
                    <button className="btn btn_success" onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? 'Saving…' : 'Save'}</button>
                </div>
            </div>
        </div >
    );
};

export default SignOnModal;
